import React, { useMemo, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  FaUser,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaLanguage,
  FaUserTag,
  FaClock,
  FaMoneyBillWave,
  FaUtensils,
  FaInfoCircle,
  FaCheckCircle,
} from "react-icons/fa";
import config, { getUserCity } from "../../../config";

const BASE_URL = config.API_BASE_URL || "http://localhost:8000";

const MEAL_OPTIONS = [
  { value: "breakfast", label: "Breakfast" },
  { value: "lunch", label: "Lunch" },
  { value: "dinner", label: "Dinner" },
];

const FOOD_TYPE_OPTIONS = [
  { value: "veg", label: "Veg" },
  { value: "non_veg", label: "Non-Veg" },
];

const CUISINE_OPTIONS = [
  { value: "south_indian", label: "South Indian" },
  { value: "north_indian", label: "North Indian" },
];

const Cooking = () => {
  const navigate = useNavigate();

  const [activeForm, setActiveForm] = useState("post");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const [showThankYou, setShowThankYou] = useState(false);

  const categoryKey = config.HOME_SERVICES_CATEGORY || "home-services";
  const serviceKey = config.COOKING_SERVICE || "cooking";

  const areaOptions = config.AREA_OPTIONS || {};
  const selectedCategory = config.SERVICE_CONFIG?.[categoryKey];
  const selectedService =
	config.SERVICE_CONFIG?.[categoryKey]?.services?.[serviceKey];

  const serviceLabel = selectedService?.label || "Cooking";
  const categoryLabel = selectedCategory?.label || "Home Services";

  const [formData, setFormData] = useState({
	username: "",
	mobilenumber: "",
	email: "",
	address: "",
	city: "",
	area: "",
	language: "",
	gender: "",
	urgencyStatus: "",
	duration: "",
	additionalNotes: "",
	salaryOffered: "",
	foodType: "",
	mealCount: "",
	mealTimes: [],
	cuisineType: "",
  });

  const [searchCriteria, setSearchCriteria] = useState({
	gender: "",
	city: "",
	area: "",
  });

  const availableAreas = useMemo(() => {
	const selected =
	  areaOptions[formData.city] || areaOptions[formData.city?.toLowerCase()];
	if (Array.isArray(selected)) return selected;
	if (selected?.areas) return selected.areas;
	return [];
  }, [formData.city, areaOptions]);

  const searchAreas = useMemo(() => {
	const selected =
	  areaOptions[searchCriteria.city] ||
	  areaOptions[searchCriteria.city?.toLowerCase()];
	if (Array.isArray(selected)) return selected;
	if (selected?.areas) return selected.areas;
	return [];
  }, [searchCriteria.city, areaOptions]);

  const styles = {
	page: {
	  minHeight: "100vh",
	  background:
		"linear-gradient(135deg, #eff6ff 0%, #dbeafe 50%, #eef2ff 100%)",
	  padding: "30px 20px",
	  fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
	},
	wrapper: {
	  maxWidth: "1580px",
	  width: "96%",
	  margin: "0 auto",
	},
	hero: {
	  background: "linear-gradient(135deg, #0f172a, #1d4ed8, #38bdf8)",
	  color: "#fff",
	  borderRadius: "28px",
	  padding: "34px 36px",
	  boxShadow: "0 20px 40px rgba(37, 99, 235, 0.22)",
	  marginBottom: "24px",
	},
	heroBadge: {
	  display: "inline-block",
	  background: "rgba(255,255,255,0.14)",
	  padding: "7px 14px",
	  borderRadius: "999px",
	  fontSize: "12px",
	  fontWeight: "700",
	  marginBottom: "12px",
	},
	heroTitle: {
	  margin: 0,
	  fontSize: "2.1rem",
	  fontWeight: "800",
	},
	heroText: {
	  marginTop: "10px",
	  marginBottom: 0,
	  color: "rgba(255,255,255,0.9)",
	  maxWidth: "900px",
	  lineHeight: 1.6,
	  fontSize: "15px",
	},
	switchWrap: {
	  display: "flex",
	  gap: "12px",
	  flexWrap: "wrap",
	  marginBottom: "22px",
	},
	switchBtn: {
	  border: "1px solid #cbd5e1",
	  borderRadius: "999px",
	  padding: "12px 20px",
	  background: "#fff",
	  color: "#334155",
	  fontSize: "14px",
	  fontWeight: "800",
	  cursor: "pointer",
	  boxShadow: "0 6px 16px rgba(15, 23, 42, 0.06)",
	},
	switchBtnActive: {
	  background: "linear-gradient(135deg, #1d4ed8, #2563eb)",
	  color: "#fff",
	  border: "1px solid #2563eb",
	  boxShadow: "0 12px 24px rgba(37, 99, 235, 0.22)",
	},
	formCard: {
	  background: "#fff",
	  borderRadius: "28px",
	  border: "1px solid #e5edf8",
	  boxShadow: "0 14px 34px rgba(15, 23, 42, 0.08)",
	  overflow: "hidden",
	  width: "100%",
	  maxWidth: "1320px",
	  margin: "0 auto",
	},
	formHeader: {
	  padding: "28px 40px",
	  borderBottom: "1px solid #edf2f7",
	  background: "linear-gradient(180deg, #ffffff, #f8fbff)",
	},
	formTitle: {
	  margin: 0,
	  fontSize: "1.6rem",
	  fontWeight: "800",
	  color: "#0f172a",
	},
	formSub: {
	  margin: "8px 0 0 0",
	  color: "#64748b",
	  fontSize: "14px",
	},
	body: {
	  padding: "32px 40px 36px",
	},
	section: {
	  marginBottom: "28px",
	  padding: "24px",
	  borderRadius: "20px",
	  background: "#f8fbff",
	  border: "1px solid #e6eef8",
	},
	sectionTitle: {
	  margin: "0 0 18px 0",
	  fontSize: "1.1rem",
	  fontWeight: "800",
	  color: "#0f172a",
	  display: "flex",
	  alignItems: "center",
	  gap: "8px",
	},
	grid: {
	  display: "grid",
	  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
	  gap: "20px",
	  alignItems: "start",
	},
	field: {
	  display: "flex",
	  flexDirection: "column",
	  gap: "8px",
	},
	label: {
	  fontSize: "14px",
	  fontWeight: "700",
	  color: "#334155",
	  display: "flex",
	  alignItems: "center",
	  gap: "8px",
	},
	input: {
	  width: "100%",
	  padding: "14px 16px",
	  borderRadius: "14px",
	  border: "1px solid #d6deeb",
	  fontSize: "15px",
	  outline: "none",
	  background: "#fff",
	  boxSizing: "border-box",
	},
	select: {
	  width: "100%",
	  padding: "14px 16px",
	  borderRadius: "14px",
	  border: "1px solid #d6deeb",
	  fontSize: "15px",
	  outline: "none",
	  background: "#fff",
	  boxSizing: "border-box",
	},
	textarea: {
	  width: "100%",
	  minHeight: "120px",
	  padding: "14px 16px",
	  borderRadius: "14px",
	  border: "1px solid #d6deeb",
	  fontSize: "15px",
	  outline: "none",
	  background: "#fff",
	  boxSizing: "border-box",
	  resize: "vertical",
	},
	submitWrap: {
	  display: "flex",
	  justifyContent: "center",
	  marginTop: "30px",
	},
	submitBtn: {
	  border: "none",
	  borderRadius: "999px",
	  background: "linear-gradient(135deg, #1d4ed8, #2563eb)",
	  color: "#fff",
	  padding: "15px 34px",
	  fontSize: "15px",
	  fontWeight: "800",
	  minWidth: "260px",
	  boxShadow: "0 12px 24px rgba(37, 99, 235, 0.24)",
	  cursor: "pointer",
	},
	helper: {
	  color: "#64748b",
	  fontSize: "13px",
	  margin: 0,
	  lineHeight: 1.6,
	},
	checkboxRow: {
	  display: "flex",
	  alignItems: "center",
	  justifyContent: "space-between",
	  padding: "10px 14px",
	  borderRadius: "12px",
	  border: "1px solid #dbe7f5",
	  background: "#fff",
	  marginTop: "10px",
	},
	checkboxLabel: {
	  fontSize: "14px",
	  fontWeight: "600",
	  color: "#0f172a",
	},
	checkbox: {
	  width: "18px",
	  height: "18px",
	  cursor: "pointer",
	},
	popupOverlay: {
	  position: "fixed",
	  inset: 0,
	  backgroundColor: "rgba(15, 23, 42, 0.45)",
	  display: "flex",
	  alignItems: "center",
	  justifyContent: "center",
	  zIndex: 50,
	},
	popupCard: {
	  background: "#fff",
	  borderRadius: "18px",
	  padding: "22px 24px",
	  maxWidth: "360px",
	  width: "90%",
	  textAlign: "center",
	  boxShadow: "0 20px 40px rgba(15, 23, 42, 0.25)",
	},
	popupTitle: {
	  margin: "10px 0 6px 0",
	  fontSize: "1.1rem",
	  fontWeight: "800",
	  color: "#065f46",
	},
	popupText: {
	  margin: 0,
	  fontSize: "14px",
	  color: "#4b5563",
	},
	popupButton: {
	  marginTop: "16px",
	  borderRadius: "999px",
	  border: "none",
	  background: "#16a34a",
	  color: "#fff",
	  fontSize: "14px",
	  fontWeight: "700",
	  padding: "10px 24px",
	  cursor: "pointer",
	},
  };

  const handleInputChange = (e) => {
	const { name, value } = e.target;
	const cleanValue =
	  name === "mobilenumber" ? value.replace(/\D/g, "").slice(0, 10) : value;

	setFormData((prev) => ({
	  ...prev,
	  [name]: cleanValue,
	  ...(name === "city" ? { area: "" } : {}),
	}));
  };

  const handleSearchChange = (e) => {
	const { name, value } = e.target;
	setSearchCriteria((prev) => ({
	  ...prev,
	  [name]: value,
	  ...(name === "city" ? { area: "" } : {}),
	}));
  };

  const handleFoodTypeCheckbox = (value) => {
	setFormData((prev) => ({
	  ...prev,
	  foodType: prev.foodType === value ? "" : value,
	}));
  };

  const handleMealCountCheckbox = (value) => {
	setFormData((prev) => ({
	  ...prev,
	  mealCount: prev.mealCount === value ? "" : value,
	}));
  };

  const handleMealTimeCheckbox = (value) => {
	setFormData((prev) => {
	  const exists = prev.mealTimes.includes(value);
	  return {
		...prev,
		mealTimes: exists
		  ? prev.mealTimes.filter((item) => item !== value)
		  : [...prev.mealTimes, value],
	  };
	});
  };

  const handleCuisineCheckbox = (value) => {
	setFormData((prev) => ({
	  ...prev,
	  cuisineType: prev.cuisineType === value ? "" : value,
	}));
  };

  const handleSearchCheckLabour = async (e) => {
	e.preventDefault();

	if (!searchCriteria.gender || !searchCriteria.city || !searchCriteria.area) {
	  alert("Please fill all fields before searching");
	  return;
	}

	try {
	  setIsSearching(true);

	  const requestBody = {
		...searchCriteria,
		work_category: "cooking",
		service_category: categoryKey,
		service: serviceKey,
	  };

	  const response = await fetch(`${BASE_URL}/api/search/labour-cook/`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(requestBody),
	  });

	  const data = await response.json();

	  if (response.ok) {
		navigate("/labour-list", {
		  state: {
			labours: data.labours,
			work_category: "Cooking",
		  },
		});
	  } else {
		alert(data.error || "Failed to search labour.");
	  }
	} catch (error) {
	  console.error("Request failed:", error);
	  alert("Request failed while searching labour.");
	} finally {
	  setIsSearching(false);
	}
  };

  const handleSubmit = async (e) => {
	e.preventDefault();

	if (!formData.foodType) {
	  alert("Please select Veg or Non-Veg");
	  return;
	}
	if (!formData.mealCount) {
	  alert("Please select how many times cook should prepare meals");
	  return;
	}
	if (formData.mealTimes.length === 0) {
	  alert("Please select at least one meal (Breakfast/Lunch/Dinner)");
	  return;
	}
	if (!formData.cuisineType) {
	  alert("Please select cuisine type");
	  return;
	}

	try {
	  setIsSubmitting(true);

	  const requestBody = {
		...formData,
		service_category: categoryKey,
		selected_city: getUserCity(),
		service: serviceKey,
		category_label: categoryLabel,
		service_label: serviceLabel,
	  };

	  const response = await axios.post(
		`${BASE_URL}/api/service/requirements/`,
		requestBody,
		{
		  headers: {
			"Content-Type": "application/json",
		  },
		}
	  );

	  if (response.status === 200 || response.status === 201) {
		setShowThankYou(true);
	  }
	} catch (error) {
	  console.error("Error submitting form:", error);
	  alert(
		error.response?.data?.error ||
		  "There was an error submitting your request."
	  );
	} finally {
	  setIsSubmitting(false);
	}
  };

  const selectedFoodTypeLabel =
	FOOD_TYPE_OPTIONS.find((i) => i.value === formData.foodType)?.label || "";

  const selectedCuisineLabel =
	CUISINE_OPTIONS.find((i) => i.value === formData.cuisineType)?.label || "";

  return (
	<>
	  {showThankYou && (
		<div style={styles.popupOverlay}>
		  <div style={styles.popupCard}>
			<FaCheckCircle color="#16a34a" size={32} />
			<h3 style={styles.popupTitle}>Thank you!</h3>
			<p style={styles.popupText}>
			  Your requirement has been submitted. We will get back to you
			  shortly.
			</p>
			<button
			  type="button"
			  style={styles.popupButton}
			  onClick={() => {
				setShowThankYou(false);
				navigate("/");
			  }}
			>
			  OK
			</button>
		  </div>
		</div>
	  )}

	  <div style={styles.page}>
		<div style={styles.wrapper}>
		  <div style={styles.hero}>
			<div style={styles.heroBadge}>{serviceLabel}</div>
			<h1 style={styles.heroTitle}>
			  Hire a Home Cook or Search Cooking Labour
			</h1>
			<p style={styles.heroText}>
			  Post your cooking requirement with simple checkbox preferences,
			  location details, and salary offer, or search available cooks by
			  city and area.
			</p>
		  </div>

		  <div style={styles.switchWrap}>
			<button
			  type="button"
			  style={{
				...styles.switchBtn,
				...(activeForm === "post" ? styles.switchBtnActive : {}),
			  }}
			  onClick={() => setActiveForm("post")}
			>
			  Post Your Requirement
			</button>

			<button
			  type="button"
			  style={{
				...styles.switchBtn,
				...(activeForm === "search" ? styles.switchBtnActive : {}),
			  }}
			  onClick={() => setActiveForm("search")}
			>
			  Check Labour
			</button>
		  </div>

		  {activeForm === "post" ? (
			<form style={styles.formCard} onSubmit={handleSubmit}>
			  <div style={styles.formHeader}>
				<h2 style={styles.formTitle}>
				  Cooking Labour Requirement Form
				</h2>
				<p style={styles.formSub}>
				  Fill in your personal details, select preferences using
				  checkboxes, and mention your salary offer.
				</p>
			  </div>

			  <div style={styles.body}>
				{/* Personal details */}
				<div style={styles.section}>
				  <h3 style={styles.sectionTitle}>Personal Details</h3>
				  <div style={styles.grid}>
					<div style={styles.field}>
					  <label htmlFor="username" style={styles.label}>
						<FaUser /> Name
					  </label>
					  <input
						id="username"
						style={styles.input}
						type="text"
						name="username"
						value={formData.username}
						onChange={handleInputChange}
						required
					  />
					</div>

					<div style={styles.field}>
					  <label htmlFor="mobilenumber" style={styles.label}>
						<FaPhoneAlt /> Mobile Number
					  </label>
					  <input
						id="mobilenumber"
						style={styles.input}
						type="tel"
						name="mobilenumber"
						value={formData.mobilenumber}
						onChange={handleInputChange}
						pattern="[0-9]{10}"
						minLength={10}
						maxLength={10}
						required
					  />
					</div>

					<div style={styles.field}>
					  <label htmlFor="email" style={styles.label}>
						<FaEnvelope /> Email
					  </label>
					  <input
						id="email"
						style={styles.input}
						type="email"
						name="email"
						value={formData.email}
						onChange={handleInputChange}
						required
					  />
					</div>

					<div style={styles.field}>
					  <label htmlFor="address" style={styles.label}>
						<FaMapMarkerAlt /> Address
					  </label>
					  <input
						id="address"
						style={styles.input}
						type="text"
						name="address"
						value={formData.address}
						onChange={handleInputChange}
						required
					  />
					</div>

					<div style={styles.field}>
					  <label htmlFor="city" style={styles.label}>
						<FaMapMarkerAlt /> City
					  </label>
					  <select
						id="city"
						style={styles.select}
						name="city"
						value={formData.city}
						onChange={handleInputChange}
						required
					  >
						<option value="">Select City</option>
						{Object.keys(areaOptions).map((city) => (
						  <option key={city} value={city}>
							{city.charAt(0).toUpperCase() + city.slice(1)}
						  </option>
						))}
					  </select>
					</div>

					<div style={styles.field}>
					  <label htmlFor="area" style={styles.label}>
						<FaMapMarkerAlt /> Area
					  </label>
					  <select
						id="area"
						style={styles.select}
						name="area"
						value={formData.area}
						onChange={handleInputChange}
						required
						disabled={!formData.city}
					  >
						<option value="">Select Area</option>
						{availableAreas.map((area) => (
						  <option key={area} value={area}>
							{area}
						  </option>
						))}
					  </select>
					</div>

					<div style={styles.field}>
					  <label htmlFor="language" style={styles.label}>
						<FaLanguage /> Preferred Language
					  </label>
					  <input
						id="language"
						style={styles.input}
						type="text"
						name="language"
						placeholder="Hindi, English, Kannada etc"
						value={formData.language}
						onChange={handleInputChange}
						required
					  />
					</div>

					<div style={styles.field}>
					  <label htmlFor="gender" style={styles.label}>
						<FaUserTag /> Preferred Cook Gender
					  </label>
					  <select
						id="gender"
						style={styles.select}
						name="gender"
						value={formData.gender}
						onChange={handleInputChange}
						required
					  >
						<option value="">Select</option>
						<option value="Male">Male</option>
						<option value="Female">Female</option>
						<option value="Others">Others</option>
					  </select>
					</div>

					<div style={styles.field}>
					  <label htmlFor="urgencyStatus" style={styles.label}>
						<FaClock /> Urgency
					  </label>
					  <select
						id="urgencyStatus"
						style={styles.select}
						name="urgencyStatus"
						value={formData.urgencyStatus}
						onChange={handleInputChange}
						required
					  >
						<option value="">Select</option>
						<option value="immediate">Immediate</option>
						<option value="within_1_week">Within 1 Week</option>
						<option value="just_enquiry">Just Enquiry</option>
					  </select>
					</div>

					<div style={styles.field}>
					  <label htmlFor="duration" style={styles.label}>
						<FaClock /> Duration
					  </label>
					  <input
						id="duration"
						style={styles.input}
						type="text"
						name="duration"
						placeholder="In months"
						value={formData.duration}
						onChange={handleInputChange}
						required
					  />
					</div>

					<div style={styles.field}>
					  <label htmlFor="salaryOffered" style={styles.label}>
						<FaMoneyBillWave /> Salary Offer
					  </label>
					  <input
						id="salaryOffered"
						style={styles.input}
						type="text"
						name="salaryOffered"
						placeholder="Per month, e.g. 10000 rs/month"
						value={formData.salaryOffered}
						onChange={handleInputChange}
						required
					  />
					</div>
				  </div>
				</div>

				{/* Food & cooking preferences with checkboxes */}
				<div style={styles.section}>
				  <h3 style={styles.sectionTitle}>
					<FaUtensils />
					Food & Cooking Preferences
				  </h3>

				  <p style={styles.helper}>Choose the preferred food type.</p>
				  {FOOD_TYPE_OPTIONS.map((item) => (
					<div key={item.value} style={styles.checkboxRow}>
					  <span style={styles.checkboxLabel}>{item.label}</span>
					  <input
						type="checkbox"
						style={styles.checkbox}
						checked={formData.foodType === item.value}
						onChange={() => handleFoodTypeCheckbox(item.value)}
					  />
					</div>
				  ))}

				  <p style={{ ...styles.helper, marginTop: "18px" }}>
					How many times should the cook prepare meals per day?
				  </p>
				  {["1", "2", "3"].map((count) => (
					<div key={count} style={styles.checkboxRow}>
					  <span style={styles.checkboxLabel}>
						{count} time{count !== "1" ? "s" : ""}
					  </span>
					  <input
						type="checkbox"
						style={styles.checkbox}
						checked={formData.mealCount === count}
						onChange={() => handleMealCountCheckbox(count)}
					  />
					</div>
				  ))}

				  <p style={{ ...styles.helper, marginTop: "18px" }}>
					Select which meals should be prepared.
				  </p>
				  {MEAL_OPTIONS.map((item) => (
					<div key={item.value} style={styles.checkboxRow}>
					  <span style={styles.checkboxLabel}>{item.label}</span>
					  <input
						type="checkbox"
						style={styles.checkbox}
						checked={formData.mealTimes.includes(item.value)}
						onChange={() => handleMealTimeCheckbox(item.value)}
					  />
					</div>
				  ))}

				  <p style={{ ...styles.helper, marginTop: "18px" }}>
					Choose the cuisine style for daily cooking.
				  </p>
				  {CUISINE_OPTIONS.map((item) => (
					<div key={item.value} style={styles.checkboxRow}>
					  <span style={styles.checkboxLabel}>{item.label}</span>
					  <input
						type="checkbox"
						style={styles.checkbox}
						checked={formData.cuisineType === item.value}
						onChange={() => handleCuisineCheckbox(item.value)}
					  />
					</div>
				  ))}
				</div>

				{/* Summary & notes */}
				<div style={styles.section}>
				  <h3 style={styles.sectionTitle}>
					<FaInfoCircle />
					Summary & Notes
				  </h3>
				  <p style={styles.helper}>
					Review your preferences and share any additional information
					for the cook.
				  </p>

				  <div
					style={{
					  marginTop: "12px",
					  fontSize: "14px",
					  color: "#0f172a",
					}}
				  >
					{formData.foodType && (
					  <p>
						<strong>Food Type:</strong> {selectedFoodTypeLabel}
					  </p>
					)}

					{formData.mealCount && (
					  <p>
						<strong>Times per Day:</strong> {formData.mealCount} time
						{formData.mealCount !== "1" ? "s" : ""}
					  </p>
					)}

					{formData.mealTimes.length > 0 && (
					  <p>
						<strong>Meals:</strong>{" "}
						{formData.mealTimes
						  .map(
							(m) =>
							  MEAL_OPTIONS.find((o) => o.value === m)?.label || m
						  )
						  .join(", ")}
					  </p>
					)}

					{formData.cuisineType && (
					  <p>
						<strong>Cuisine:</strong> {selectedCuisineLabel}
					  </p>
					)}

					{formData.salaryOffered && (
					  <p>
						<strong>Salary Offer:</strong> {formData.salaryOffered}
					  </p>
					)}
				  </div>

				  <div style={{ marginTop: "14px" }}>
					<label htmlFor="additionalNotes" style={styles.label}>
					  <FaInfoCircle /> Notes
					</label>
					<textarea
					  id="additionalNotes"
					  style={styles.textarea}
					  name="additionalNotes"
					  placeholder="Mention family size, separate veg/non-veg handling, festival meals, etc."
					  value={formData.additionalNotes}
					  onChange={handleInputChange}
					/>
				  </div>
				</div>

				<div style={styles.submitWrap}>
				  <button
					type="submit"
					style={styles.submitBtn}
					disabled={isSubmitting}
				  >
					{isSubmitting ? "Submitting..." : "Submit Requirement"}
				  </button>
				</div>
			  </div>
			</form>
		  ) : (
			<form style={styles.formCard} onSubmit={handleSearchCheckLabour}>
			  <div style={styles.formHeader}>
				<h2 style={styles.formTitle}>Search Cooking Labour</h2>
				<p style={styles.formSub}>
				  Select gender, city, and area to find available cooks near
				  your location.
				</p>
			  </div>

			  <div style={styles.body}>
				<div style={styles.section}>
				  <h3 style={styles.sectionTitle}>Search Filters</h3>

				  <div style={styles.grid}>
					<div style={styles.field}>
					  <label htmlFor="search-gender" style={styles.label}>
						<FaUserTag /> Gender
					  </label>
					  <select
						id="search-gender"
						style={styles.select}
						name="gender"
						value={searchCriteria.gender}
						onChange={handleSearchChange}
						required
					  >
						<option value="">Select</option>
						<option value="Male">Male</option>
						<option value="Female">Female</option>
					  </select>
					</div>

					<div style={styles.field}>
					  <label htmlFor="search-city" style={styles.label}>
						<FaMapMarkerAlt /> City
					  </label>
					  <select
						id="search-city"
						style={styles.select}
						name="city"
						value={searchCriteria.city}
						onChange={handleSearchChange}
						required
					  >
						<option value="">Select City</option>
						{Object.keys(areaOptions).map((city) => (
						  <option key={city} value={city}>
							{city.charAt(0).toUpperCase() + city.slice(1)}
						  </option>
						))}
					  </select>
					</div>

					<div style={styles.field}>
					  <label htmlFor="search-area" style={styles.label}>
						<FaMapMarkerAlt /> Area
					  </label>
					  <select
						id="search-area"
						style={styles.select}
						name="area"
						value={searchCriteria.area}
						onChange={handleSearchChange}
						required
						disabled={!searchCriteria.city}
					  >
						<option value="">Select Area</option>
						{searchAreas.map((area) => (
						  <option key={area} value={area}>
							{area}
						  </option>
						))}
					  </select>
					</div>
				  </div>

				  <div style={styles.submitWrap}>
					<button
					  type="submit"
					  style={styles.submitBtn}
					  disabled={isSearching}
					>
					  {isSearching ? "Searching..." : "Search Labour"}
					</button>
				  </div>
				</div>
			  </div>
			</form>
		  )}
		</div>
	  </div>
	</>
  );
};

export default Cooking;